import { useEffect, useState } from "react";

export default function FirstView() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="pt-16">
      <section className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/ae4850017960653831fb63cab00a2978.png"
            alt="診療シーン"
            fetchPriority="high"
            className="w-full h-full object-cover md:object-top"
            style={{
              objectPosition: '22% 38%',
              filter: 'brightness(1.1)'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          {/* 視認性向上のための薄いオーバーレイ */}
          <div 
            className="absolute inset-0 hidden md:block" 
            style={{
              background: 'linear-gradient(90deg, rgba(247,249,252,0.08) 0%, rgba(247,249,252,0.18) 55%, rgba(247,249,252,0.25) 100%)'
            }}
          ></div>
          {/* スマホ用のオーバーレイ */}
          <div 
            className="absolute inset-0 md:hidden" 
            style={{
              background: 'linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.08) 50%, rgba(0,0,0,0.12) 100%)'
            }}
          ></div>
        </div>

        {/* ===== デスクトップレイアウト ===== */}
        <div 
          className="hidden md:flex relative z-10 h-full flex-col justify-center px-6"
          style={{ marginTop: '-24px' }}
        >
          <div className="max-w-[680px] w-full ml-[440px] lg:ml-[520px] xl:ml-[600px]">
            <h2
              className="text-4xl lg:text-5xl font-normal text-left transition-all duration-[2000ms] ease-out font-serif"
              style={{
                lineHeight: '1.5',
                letterSpacing: '0.02em',
                color: '#1A2A3A',
                textShadow: '0 1px 12px rgba(255,255,255,0.7), 0 1px 4px rgba(255,255,255,0.5)',
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateX(0)' : 'translateX(60px)',
              }}
            >
              <span
                className="block text-sm font-medium tracking-widest mb-3"
                style={{ fontFamily: 'Noto Sans JP, sans-serif', color: 'rgba(62,95,143,0.9)', fontSize: '0.8rem' }}
              >
                マウスピース矯正・ホワイトニング 札幌
              </span>
              <div>矯正で後悔しないために
最初に知っておくべき"判断基準"があります。</div>
            </h2>
            
            <p 
              className="text-sm font-light text-left mt-5"
              style={{ 
                lineHeight: '1.8',
                color: 'rgba(20,30,45,0.85)',
                textShadow: '0 1px 8px rgba(255,255,255,0.6), 0 1px 2px rgba(255,255,255,0.4)',
              }}
            >
              北海道でも数少ない、精密診断を行う環境で<br />
              あなたに最適な治療を導き出します。
            </p>

            <div className="flex flex-row gap-4 items-start mt-6">
              <a
                href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-90 text-white text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-block text-center"
                style={{
                  width: '200px',
                  height: '46px',
                  lineHeight: '46px',
                  padding: '0 32px',
                  borderRadius: '23px',
                  backgroundColor: '#3E5F8F'
                }}
              >
                WEB予約
              </a>
              <a
                href="tel:05018094594"
                className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-block text-center"
                style={{
                  width: '200px',
                  height: '46px',
                  lineHeight: '46px',
                  padding: '0 32px',
                  borderRadius: '23px',
                  color: '#3E5F8F',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: 'rgba(244,246,250,0.55)'
                }}
              >
                電話で相談
              </a>
            </div>

            <p 
              className="text-xs mt-4 text-left" 
              style={{ 
                color: 'rgba(20,30,45,0.65)',
                textShadow: '0 1px 6px rgba(255,255,255,0.5)',
              }}
            >
              相談だけでも大丈夫です
            </p>
          </div>
        </div>

        {/* ===== スマホレイアウト：上下に分割 ===== */}
        <div className="md:hidden relative z-10 h-full flex flex-col justify-end px-5 pb-10">
          {/* キャッチコピー */}
          <div className="w-full mb-4">
            <h1
              className="text-3xl font-normal text-left transition-all duration-[2000ms] ease-out font-serif"
              style={{
                lineHeight: '1.5',
                letterSpacing: '0.02em',
                color: '#1A2A3A',
                textShadow: [
                  '0 0 18px rgba(255,255,255,0.95)',
                  '0 0 10px rgba(255,255,255,0.9)',
                  '0 0 4px rgba(255,255,255,0.85)',
                  '2px 2px 0 rgba(255,255,255,0.6)',
                  '-2px -2px 0 rgba(255,255,255,0.6)',
                  '2px -2px 0 rgba(255,255,255,0.6)',
                  '-2px 2px 0 rgba(255,255,255,0.6)',
                ].join(', '),
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateX(0)' : 'translateX(60px)',
              }}
            >
              <span
                className="block text-xs font-medium tracking-widest mb-2"
                style={{ fontFamily: 'Noto Sans JP, sans-serif', color: 'rgba(62,95,143,0.9)' }}
              >
                マウスピース矯正・ホワイトニング 札幌
              </span>
              <div>矯正で後悔しないために
最初に知っておくべき&quot;判断基準&quot;があります。</div>
            </h1>

            <p 
              className="text-xs font-light text-right mt-2"
              style={{ 
                lineHeight: '1.8',
                color: 'rgba(20,30,45,0.9)',
                textShadow: [
                  '0 0 12px rgba(255,255,255,0.95)',
                  '0 0 6px rgba(255,255,255,0.9)',
                  '1px 1px 0 rgba(255,255,255,0.7)',
                  '-1px -1px 0 rgba(255,255,255,0.7)',
                ].join(', '),
              }}
            >
              北海道でも数少ない、精密診断を行う環境で<br />
              あなたに最適な治療を導き出します。
            </p>
          </div>

          {/* CTAボタン */}
          <div className="flex flex-col gap-2.5 items-center">
            <a
              href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-90 text-white text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-block text-center"
              style={{
                width: 'min(320px, 86vw)',
                height: '46px',
                lineHeight: '46px',
                padding: '0 32px',
                borderRadius: '23px',
                backgroundColor: '#3E5F8F'
              }}
            >
              WEB予約
            </a>
            <a
              href="tel:05018094594"
              className="hover:bg-white/30 backdrop-blur-sm text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-block text-center"
              style={{
                width: 'min(320px, 86vw)',
                height: '46px',
                lineHeight: '46px',
                padding: '0 32px',
                borderRadius: '23px',
                color: '#1A2A3A',
                background: 'rgba(255,255,255,0.45)',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'rgba(255,255,255,0.6)'
              }}
            >
              電話で相談
            </a>
          </div>

          <p 
            className="text-xs mt-2.5 text-right" 
            style={{ 
              color: 'rgba(20,30,45,0.75)',
              textShadow: '0 0 10px rgba(255,255,255,0.95), 0 0 4px rgba(255,255,255,0.9)',
            }}
          >
            相談だけでも大丈夫です
          </p>
        </div>
      </section>
    </div>
  );
}
